import { render, staticRenderFns } from "./chat-img.vue?vue&type=template&id=73d0c660&scoped=true&"
import script from "./chat-img.vue?vue&type=script&lang=js&"
export * from "./chat-img.vue?vue&type=script&lang=js&"
import style0 from "./chat-img.vue?vue&type=style&index=0&id=73d0c660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d0c660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
